"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSession = exports.isSuperAdminSession = exports.isStaffSession = exports.isParticipantSession = void 0;
function isParticipantSession(value) {
    if (!value || typeof value !== "object") {
        return false;
    }
    return typeof value.participantId === "number";
}
exports.isParticipantSession = isParticipantSession;
function isStaffSession(value) {
    if (!value || typeof value !== "object") {
        return false;
    }
    return typeof value.staffId === "number";
}
exports.isStaffSession = isStaffSession;
function isSuperAdminSession(value) {
    if (!value || typeof value !== "object") {
        return false;
    }
    return typeof value.superAdminId === "number";
}
exports.isSuperAdminSession = isSuperAdminSession;
function isSession(value) {
    return (isParticipantSession(value) ||
        isStaffSession(value) ||
        isSuperAdminSession(value));
}
exports.isSession = isSession;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2Vzc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbnRlcmZhY2VzL1Nlc3Npb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBY0EsU0FBZ0Isb0JBQW9CLENBQ2xDLEtBQWM7SUFFZCxJQUFJLENBQUMsS0FBSyxJQUFJLE9BQU8sS0FBSyxLQUFLLFFBQVEsRUFBRTtRQUN2QyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsT0FBTyxPQUFRLEtBQTZCLENBQUMsYUFBYSxLQUFLLFFBQVEsQ0FBQztBQUMxRSxDQUFDO0FBUEQsb0RBT0M7QUFFRCxTQUFnQixjQUFjLENBQUMsS0FBYztJQUMzQyxJQUFJLENBQUMsS0FBSyxJQUFJLE9BQU8sS0FBSyxLQUFLLFFBQVEsRUFBRTtRQUN2QyxPQUFPLEtBQUssQ0FBQztLQUNkO0lBQ0QsT0FBTyxPQUFRLEtBQTZCLENBQUMsT0FBTyxLQUFLLFFBQVEsQ0FBQztBQUNwRSxDQUFDO0FBTEQsd0NBS0M7QUFFRCxTQUFnQixtQkFBbUIsQ0FDakMsS0FBYztJQUVkLElBQUksQ0FBQyxLQUFLLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUSxFQUFFO1FBQ3ZDLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFDRCxPQUFPLE9BQVEsS0FBNkIsQ0FBQyxZQUFZLEtBQUssUUFBUSxDQUFDO0FBQ3pFLENBQUM7QUFQRCxrREFPQztBQUVELFNBQWdCLFNBQVMsQ0FBQyxLQUFjO0lBQ3RDLE9BQU8sQ0FDTCxvQkFBb0IsQ0FBQyxLQUFLLENBQUM7UUFDM0IsY0FBYyxDQUFDLEtBQUssQ0FBQztRQUNyQixtQkFBbUIsQ0FBQyxLQUFLLENBQUMsQ0FDM0IsQ0FBQztBQUNKLENBQUM7QUFORCw4QkFNQyJ9